import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppraisalService } from '../services/appraisal.service';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-assessment-l4',
  templateUrl: './assessment-l4.component.html',
  styleUrls: ['./assessment-l4.component.css']
})
export class AssessmentL4Component implements OnInit {
  clickStatus = false;
  alreadySubmit = false;
  alreadyDraft = false;
   form_id;
   formData =
  {
    'form_id':''
  };
  userData = {}

  constructor( private apprais : AppraisalService, private router: Router, private route: ActivatedRoute, public ls : LoginService) { }

  ngOnInit() {
    var today = new Date();
    this.form_id = this.route.snapshot.params.form_id;
    this.formData.form_id = this.form_id;
    var user = this.apprais.getFormInfo(this.formData).subscribe(res=>{
     // console.log(res);
      this.userData =  res.form_info;
      this.userData['employee_DOB'] = this.dateFun(res.form_info.employee_DOB);
      this.userData['employee_DOA'] = this.dateFun(res.form_info.employee_DOA);
      this.userData['employee_LPM'] = this.dateFun(res.form_info.employee_LPM);
      this.userData['l4_name'] = this.ls.name;
      this.userData['form_id'] = this.form_id;
      this.userData['l4_entry_date'] = this.dateFun(today);
      if(!this.userData['l4_grading'])
      {
        this.userData['l4_grading'] = this.userData['l3_grading'];
      }
      //alert(this.userData['l4_grading']);
      
      this.userData['l4_grading_remarks'] = this.userData['l3_grading_remarks'];
     // console.log(this.userData);
    })
  }

  isValid(l3assessment,control) 
  {
   
    if((!l3assessment.controls[control].valid && (l3assessment.controls[control].dirty ||l3assessment.controls[control].touched)) || (!l3assessment.controls[control].valid && this.clickStatus))
    {
      // var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
      var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }
  onDraft(l3assessment)
  {
    this.alreadyDraft = true;
    var formDataSet = l3assessment.value;
    formDataSet['l4_grading_remarks'] =this.getGradeRemarks(formDataSet.l4_grading);
    formDataSet['l4_is_appraisal_submit'] = '0';
    //console.log(formDataSet);
    var selfData = this.apprais.setL4GradData(formDataSet).subscribe( res => {
     
      if(formDataSet.form_type == '1')
      {
        localStorage.setItem('appraisal_msg',res.message);
        this.router.navigate(['/selfAppraisalAssign']);
      }
      else{
        localStorage.setItem('nus_msg',res.message);
        this.router.navigate(['/nsuAssignL2']);
      }
     }) 

  }
  onSubmit(l3assessment)
  {
    /*console.log(this.userData);
    var selfData = this.apprais.setL2GradData(this.userData).subscribe( res => {
      localStorage.setItem('appraisal_msg',res.message);
     
     })*/
    this.clickStatus = true;
    if(l3assessment.valid)
    {
     this.alreadySubmit = true;
     var formDataSet = l3assessment.value;
     formDataSet['l4_is_appraisal_submit'] = '1';
     formDataSet['l4_grading_remarks'] =this.getGradeRemarks(formDataSet.l4_grading);

    var selfData = this.apprais.setL4GradData(formDataSet).subscribe( res => {
      if(formDataSet.form_type == '1')
      {
        localStorage.setItem('appraisal_msg',res.message);
        this.router.navigate(['/selfAppraisalAssign']);
      }
      else{
        localStorage.setItem('nus_msg',res.message);
        this.router.navigate(['/nsuAssignL2']);
      }
     })
    }
  }
  getGradeRemarks(val)
  {
    var remarks = '';
   
    var l2_grading = (typeof val === 'number')?val:0;
   
    if((l2_grading>90))
    {
      remarks = 'Outstanding';
    }
    else if((l2_grading>71) && (l2_grading<=90))
    {
      remarks = 'Very Good';
    }
    else if((l2_grading>55) && (l2_grading<=70))
    {
      remarks = 'Good';
    }
    else if((l2_grading>=40) && (l2_grading<=54))
    {
      remarks = 'Average';
    }
    else 
    {
      remarks = 'Unsatisfactory';
    }
    return remarks;

  }
  dateFun(dateStr)
  {
    var dateObj = new Date(dateStr);
    var month = dateObj.getMonth()+1; //months from 1-12
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    
    var newdate = year + "-" + month + "-" + day;
    //var newdate = day + "/" + month + "/" + year;
    //console.log(newdate);
    return newdate;
    
  }
  conFun(l3assessment)
  {
    var r = confirm("Are you sure to submit the review?");
    if (r == true) {
      this.onSubmit(l3assessment);
    }
  }

  fullPerformance(form_type,l2_performance_rating)
  {
    var remarks = '';
     var l2_grading = (typeof l2_performance_rating === 'number')?l2_performance_rating:0;
    if(form_type==1)
    {
      if((l2_grading==30))
      {
        remarks = 'Outstanding';
      }
      else if((l2_grading==24))
      {
        remarks = 'Very Good';
      }
      else if((l2_grading==18))
      {
        remarks = 'Good';
      }
      else if((l2_grading==12))
      {
        remarks = 'Average';
      }
      else 
      {
        remarks = 'Unsatisfactory';
      }
    }
    else{
      if((l2_grading==40))
      {
        remarks = 'Outstanding';
      }
      else if((l2_grading==32))
      {
        remarks = 'Very Good';
      }
      else if((l2_grading==24))
      {
        remarks = 'Good';
      }
      else if((l2_grading==16))
      {
        remarks = 'Average';
      }
      else 
      {
        remarks = 'Unsatisfactory';
      }
    }
    return remarks;
  }

  fullAllRating(l2_performance_rating)
  {
    var remarks = '';
    var l2_grading = (typeof l2_performance_rating === 'number')?l2_performance_rating:0;
    if((l2_grading==10))
    {
      remarks = 'Outstanding';
    }
    else if((l2_grading==8))
    {
      remarks = 'Very Good';
    }
    else if((l2_grading==6))
    {
      remarks = 'Good';
    }
    else if((l2_grading==4))
    {
      remarks = 'Average';
    }
    else 
    {
      remarks = 'Unsatisfactory';
    }
    return remarks;

  }

}



// WEBPACK FOOTER //
// ./src/app/assessment-l4/assessment-l4.component.ts